import { MagnifyingGlassIcon, PlayIcon } from "@heroicons/react/24/outline";
import {
  Button,
  Dialog,
  DialogBody,
  Typography,
} from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Workspace1 from "../../Assets/Images/workspaceHome.png";
import Logo from "../../Assets/Svg/Logo.svg";
import SignupFooter from "../../Components/Functionality/SignupFooter";
import WorkspaceOptionMenu from "../../Components/Functionality/WorkspaceOptionMenu";
import { usePlan } from "../../Context/PlanContext";
import { useSocket } from "../../Context/SocketContext";
import { useUserStore, useWorkspaceStore } from "../../Context/store";
import BasicInputField from "../../Layout/BasicInputField";
import { CustomizedInputField } from "../../Layout/CustomizedInputField";
import { handleUpgradePlan } from "../../Services/SweetAlert";
import { ADD_WORKSPACES, WorkSpaceInfo } from "../../Utils/Constant";
import { useWorkspacesByUserId } from "../../Web-Hooks/Workspace/use-workspace";
import { agentSessionLogout } from "../../api/agents/agentsApi";
import JoinRequest from "./JoinRequest";
const WorkspaceHome = () => {
  const { user, logout } = useUserStore();
  const { setWorkspaceList } = useWorkspaceStore();
  const { disconnect } = useSocket();
  const navigate = useNavigate();
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  const { data, isLoading } = useWorkspacesByUserId(user?.userId);

  const userCreatedWorkspace = data?.filter(
    (workspace) => workspace?.createdBy?.userId === user?.userId
  );

  useEffect(() => {
    setWorkspaceList(data);
  }, [data, setWorkspaceList]);

  const { currentPlan } = usePlan();

  const pilotPlanRestriction =
    userCreatedWorkspace?.length < currentPlan?.maxWorkSpaceCreateCount

  const handleCreateWorkspace = () => {
    if (!pilotPlanRestriction) {
      handleUpgradePlan(ADD_WORKSPACES, () =>
        navigate("/upgrade-plan?plan=base-plan")
      );
      return;
    }
    localStorage.setItem("newWorkspace", true);
    navigate("/createprofile");
  };

  const handleLogout = async () => {
    await agentSessionLogout({
      user_id: user?.userId,
      session_id: user?.sessionId,
    });
    disconnect();
    logout();
    navigate("/", { replace: true });
  };

  return (
    <section className="w-full h-screen flex flex-col 3xl:items-center overflow-y-auto">
      <JoinRequest />
      <section className={`xl:h-[65%] flex justify-center h-auto p-4 md:p-8 `}>
        <div className="w-full xl:w-2/4 3xl:w-auto flex flex-col gap-5 justify-evenly">
          <div className=" w-full flex flex-col gap-2 md:items-start justify-start sm:pb-4">
            <img src={Logo} alt="" className="max-h-20 3xl:max-h-28" />
          </div>
          <div className="w-full xs:h-[70%] lg:h-[60%]  flex flex-col gap-3 justify-around items-center md:items-start ">
            <div className="w-auto mx-auto md:mx-0 3xl:w-full">
              <CustomizedInputField
                prefix="Confirmed As"
                suffix="Change"
                value={user?.email}
                className={"mx-auto text-debatePalette-highlight"}
                inputClass={"!bg-debatePalette-highlight"}
                suffixClass={
                  "bg-debatePalette-highlight text-[0.775rem] text-debatePalette-title"
                }
                suffixClick={handleLogout}
              />
            </div>
            <div className="flex flex-col gap-5 items-center md:items-start">
              <Typography
                color="black"
                className="line-clamp-2 text-center md:text-start text-xl 2xl:text-3xl 3xl:text-5xl 6xl:text-6xl sm:text-2xl md:text-3xl font-bold"
              >
                {WorkSpaceInfo?.headLine}
              </Typography>
              <Typography
                variant="paragraph"
                className="w-full text-sm sm:text-sm xl:text-base text-justify md:text-start line-clamp-3 md:w-[100%] lg:w-[80%] 3xl:w-[60%]"
              >
                {WorkSpaceInfo?.subLine}
              </Typography>
              <div className="flex flex-col md:flex-row items-center w-full md:w-auto justify-start gap-4 ">
                <Button
                  id="create-workspace"
                  type="submit"
                  variant="gradient"
                  fullWidth
                  size="sm"
                  color="amber"
                  className="text-black text-md shrink-0 font-semibold normal-case rounded-md "
                  onClick={handleCreateWorkspace}
                >
                  Create a debatebase
                </Button>
                <Button
                  id="watch-video"
                  fullWidth
                  size="sm"
                  className="text-md flex gap-2 bg-[#153C58] shrink-0 md:w-auto hover:bg-[#153C58]/90 text-white font-medium justify-center items-center normal-case rounded-md"
                  onClick={() => setIsVideoOpen(true)}
                >
                  <PlayIcon className="w-5 h-5" />
                  Watch Video
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="xl:w-2/4 3xl:w-auto gap-y-10  hidden md:block p-4">
          <div className="flex justify-center h-full w-full items-center">
            <img
              src={Workspace1}
              alt=""
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </section>

      <section className={`flex-1 py-4 w-full bg-debatePalette-highlight`}>
        <div className=" h-10 w-10 relative hidden md:flex text-xs md:text-base text-gray-800 left-[45%] sm:left-[48%] md:left-[47.5%] -top-7 md:h-16 md:w-16  md:-top-10 z-100 bg-white rounded-full shadow-lg  justify-center items-center">
          OR
        </div>
        <div className=" flex flex-col gap-5 sm:gap-10 ">
          {data?.length === 0 ? (
            <div className="relative w-[90%] sm:w-[80%] md:w-[50%] lg:w-[50%] xl:w-[30%]  mx-auto">
              <BasicInputField
                readOnly={true}
                required={false}
                placeholder={"Not seeing your workspace?"}
                className={
                  "!bg-white ps-11 cursor-pointer hidden xs:block xs:!h-14 !border-blue-500 !shadow-blue-500 shadow-sm !text-black !rounded-md  placeholder:opacity-100 placeholder:!text-black placeholder:!text-md placeholder:!font-medium 2xs:placeholder:opacity-100"
                }
                labelProps={{
                  className: "hidden",
                }}
              />
              <Button
                size="sm"
                className="mx-auto text-debatePalette-title capitalize w-full xs:w-auto xs:!absolute mt-2 xs:mt-0 !bg-white xs:right-1 xs:top-3 mr-4 sm:right-3 sm:top-1 rounded "
                variant="outlined"
                onClick={handleLogout}
              >
                Try a different email
              </Button>
              <MagnifyingGlassIcon className="h-6 w-6 !absolute hidden xs:flex left-3 top-2 xs:top-4  rounded capitalize text-black" />
            </div>
          ) : (
            <div className="relative w-[90%] sm:w-[80%] md:w-[50%] lg:w-[50%] xl:w-[30%] rounded-md mx-auto ">
              <WorkspaceOptionMenu
                isLoading={isLoading}
                email={user?.email}
                filteredWorkspaceList={data}
              />
            </div>
          )}
          <SignupFooter info={WorkSpaceInfo} />
        </div>
      </section>
      <Dialog open={isVideoOpen} handler={setIsVideoOpen}>
        <DialogBody className="max-w-4xl p-0">
          <div className="relative pb-[56.25%] h-0">
            <iframe
              src="https://www.youtube.com/embed/ashtCXkF7LU?si=xUju_pCVI70uRKXe"
              title="DebateBase Introduction Video"
              className="absolute top-0 left-0 w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </DialogBody>
      </Dialog>
    </section>
  );
};

export default WorkspaceHome;
